module.exports = __webpack_public_path__ + "static/media/S3N1-5.b58f885b.svg";